export const general = {
  zh: {
    seeMoreOfLeft: "前往「",
    seeMoreOfMiddle: "籌碼分佈",
    seeMoreOfRight: "」頁看更多籌碼資訊",
  },
  en: {
    seeMoreOfLeft: "See more information of 「",
    seeMoreOfMiddle: "Institutions",
    seeMoreOfRight: "」",
  },
};
